import { render, staticRenderFns } from "./AppTabLinks.vue?vue&type=template&id=9ddd067c&scoped=true&"
import script from "./AppTabLinks.vue?vue&type=script&lang=js&"
export * from "./AppTabLinks.vue?vue&type=script&lang=js&"
import style0 from "./AppTabLinks.vue?vue&type=style&index=0&id=9ddd067c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddd067c",
  null
  
)

export default component.exports